import { List } from "immutable";
import React from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import redux from "redux";
import { TreeBranch } from "../../models/navigation";
import { Utility } from "../../utils";
import { AppState } from "../../store";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    navItems: state.nav.branches,
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
});

interface OwnProps {
    active: boolean;
    id: number;
    path: string;
    separator: boolean;
    title: string;
}

interface ConnectedState {
    navItems: List<TreeBranch | undefined>;
}

interface ConnectedDispatch {
}

interface OwnState {
    branchChildren: List<TreeBranch | undefined>;
}

type CombinedProps = ConnectedState & ConnectedDispatch & OwnProps;

export class SecondaryMenuItemComponent extends React.Component<CombinedProps, OwnState> {

    public constructor(props: any) {
        super(props);
        this.state = {
            branchChildren: List(),
        };
    }

    public componentDidMount() {
        this.setBranchChildren(this.props.active, this.props.navItems);
    }

    public componentWillReceiveProps(nextProps: Readonly<CombinedProps>) {
        this.setBranchChildren(nextProps.active, nextProps.navItems);
    }

    public render() {
        if (this.props.separator)
            return (<li className="separator"></li>);

        const isExternal = Utility.isExternalUrl(this.props.path);
        const link = isExternal
            ? <a href={this.props.path}>{this.props.title}</a>
            : <NavLink exact to={this.props.path}>{this.props.title}</NavLink>;

        if (this.props.active) {

            const children = this.state.branchChildren.map((item, i) => {
                if (!item)
                    return null;

                return (
                    <SecondaryMenuItem
                        active={item.active}
                        id={item.id}
                        key={i || 0}
                        path={item.url}
                        separator={item.separator}
                        title={item.title}
                    />
                );
            });

            const b = this.state.branchChildren.size
                ? this.state.branchChildren.first()
                : undefined;

            const level = b ? b.level : -1;

            return (
                <li className={this.props.active ? "current" : ""}>
                    <NavLink exact to={this.props.path}>
                        {this.props.title}
                    </NavLink>
                    {((): JSX.Element | null => {
                        return children.size
                            ? (level === 3
                                ? <div id="nav-tertiary"><ul>{children}</ul></div>
                                : <ul>{children}</ul>)
                            : null;
                    })()}
                </li>
            );
        }

        return (
            <li className={this.props.active ? "current" : ""}>
                {link}
            </li>
        );
    }

    private setBranchChildren(active: boolean, navItems: List<TreeBranch | undefined>) {
        if (active) {
            const branchChildren = navItems
                .filter((b) => b !== undefined && b.onNav && b.parentId === this.props.id)
                .sortBy((b) => b !== undefined && b.sort)
                .toList();
            this.setState({ ...this.state, branchChildren });
        }
        else {
            this.setState({ ...this.state, branchChildren: List() });
        }
    }
}

export const SecondaryMenuItem: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(SecondaryMenuItemComponent);



// WEBPACK FOOTER //
// ./src/components/navigation/SecondaryMenuItem.tsx